// caseDelete.js — PROD-416 (the client half of PROD-404; Alex 2026-09-30, Q69 = yes): a draft a
// physician HOLDS is not the patient's to delete, and a delete the server refuses leaves the case
// where it was. Import-free, so scripts/check-delete-held-draft.mjs executes it.
//
// ★★ THE CONTRACT. orella-api PROD-404 (U1-1d, B9, deploy D2, NOT live at 242.227.0): a patient's
//   DELETE /cases/<id> of a case whose doctor_id is set answers 404 'Case not found'. The live API
//   (v243.269.0) still deletes it (200). Both are safe here: a held draft offers no Delete, and
//   whatever the server answers, the store only removes a case the server confirmed it deleted.
//   Held = doctor_id set (the mapped case's heldByDoctor). A case only SENT to a physician
//   (target_doctor_id alone) is not held, matching PROD-404's rule.
export function isHeldByDoctor(c) {
  return !!(c && typeof c === 'object' && c.heldByDoctor === true)
}

// The one failure path of every deleteCase() caller: the case stays, and the patient is told
// (errors2.failedToDelete, en + es). Never a silent console line.
export function reportDeleteFailure(t, err) {
  console.warn('[deleteCase] not deleted:', (err && (err.status || err.message)) || err)
  try { alert(t('errors2.failedToDelete')) } catch { /* no window.alert (tests) */ }
}
